export interface ThemePreset {
  id: string;
  name: string;
  description: string;
  colors: {
    primary: string;
    secondary: string;
    // Additional theme colors could be added here
  };
}

export const themePresets: ThemePreset[] = [
  {
    id: 'default',
    name: 'Default',
    description: 'The default application theme',
    colors: {
      primary: '#F13C00',
      secondary: '#1f3473',
    },
  },
  {
    id: 'ocean',
    name: 'Ocean',
    description: 'Blue and teal color palette',
    colors: {
      primary: '#0079bf',
      secondary: '#00579b',
    },
  },
  {
    id: 'forest',
    name: 'Forest',
    description: 'Green and earthy tones',
    colors: {
      primary: '#4CAF50',
      secondary: '#2E7D32',
    },
  },
  {
    id: 'sunset',
    name: 'Sunset',
    description: 'Warm orange and purple tones',
    colors: {
      primary: '#FF8C00',
      secondary: '#8E44AD',
    },
  },
  {
    id: 'monochrome',
    name: 'Monochrome',
    description: 'Sleek black and gray palette',
    colors: {
      primary: '#424242',
      secondary: '#212121',
    },
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Your personalized color palette',
    colors: {
      primary: '#F13C00',
      secondary: '#1f3473',
    },
  },
];
